import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableBodyComponent, templateDataTableBody } from './DataTableBody';
import styles from './DataTableBody.styles.scss';
export const chameleonDataTableBody = DataTableBodyComponent.compose({
    baseName: 'data-table-body',
    template: templateDataTableBody,
    styles: withStylePrefix(styles),
});
